import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { company } from '../data/site';
import { testimonial } from '../data/credentials';
import { pageAnswers } from '../data/answers';
const benefits = [{
  title: 'Designed around your property',
  text: 'Bring planting, outdoor living and practical needs into one landscape plan.'
}, {
  title: 'Built for everyday enjoyment',
  text: 'Create places to gather with patios, outdoor kitchens, planting and fire features.'
}, {
  title: 'Care beyond installation',
  text: 'Keep commercial properties and HOA grounds cared for with maintenance, lawn programs and seasonal services.'
}];
export function AboutSection() {
  return <section id="about" aria-labelledby="about-title" className="section-y bg-ivory" data-id="element-33" data-mp="1sp2isk0165m9">
      <div className="site-container grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-34" data-mp="1nnd7r4ct5ry6">
        <div className="lg:col-span-5" data-id="element-35" data-mp="1jnvzy49wsipu">
          <p className="eyebrow text-moss" data-id="element-36" data-mp="1joxkczctehk8">Rooted in experience</p>
          <h2 id="about-title" className="mt-4 font-display text-[30px] font-medium leading-[1.12] text-charcoal sm:text-[36px] lg:text-[40px]" data-id="element-37" data-mp="sraxs381dalb">
            Creating and caring for landscapes since 1978.
          </h2>
          <p className="mt-5 text-[16px] leading-[1.7] text-charcoal/80" data-id="element-38" data-mp="ivpzaf26esgb">
            {pageAnswers.home?.summary}
          </p>
          <p className="mt-4 text-[16px] leading-[1.7] text-charcoal/80" data-id="element-39" data-mp="1bikil8n9bls7">
            Plan a new landscape, improve the one you have or arrange care for your business or HOA community.
            Our services bring planting, hardscape, outdoor living and commercial grounds care together.
          </p>
          <a href={company.aboutUrl} className="focus-ring group mt-6 inline-flex min-h-[44px] items-center gap-2 text-[14.5px] font-medium text-olive" data-id="element-40" data-mp="16jhfhtqu7pmv">
            <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-41" data-mp="3nahd233dt9qn">
              More about D.A. Alexander
            </span>
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-42" data-mp="1xq7qx1q26osj" />
          </a>
        </div>

        <div className="lg:col-span-7 lg:pt-2" data-id="element-43" data-mp="1nzlibrgreyjc">
          <ul className="border-b border-charcoal/15" data-id="element-44" data-mp="1j2cy7lc1wkfg">
            {benefits.map(b => <li key={b.title} className="grid gap-2 border-t border-charcoal/15 py-6 sm:grid-cols-[minmax(0,240px)_1fr] sm:gap-8" data-id="element-45" data-mp="1f0i00ppf2n5w">
                <h3 className="font-display text-[24px] font-medium leading-snug text-charcoal" data-id="element-46" data-mp="1a3hqg4tcz2a1">{b.title}</h3>
                <p className="text-[16px] leading-relaxed text-charcoal/70 sm:pt-1" data-id="element-47" data-mp="1038salft36s0">{b.text}</p>
              </li>)}
          </ul>

          <figure className="mt-10 bg-stone px-6 py-8 sm:px-9 lg:mt-12 lg:px-10 lg:py-10" data-id="element-48" data-mp="2zfa8erpb8dod">
            <blockquote className="font-display text-[24px] italic leading-[1.35] text-charcoal sm:text-[28px] lg:text-[30px]" data-id="element-49" data-mp="2uh0babk0z304">
              <p data-id="element-50" data-mp="32xr4ngltpnbv">“{testimonial.quote}”</p>
            </blockquote>
            <figcaption className="mt-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-51" data-mp="36z2loxqmt08g">
              <span className="text-[14px] text-charcoal/70" data-id="element-52" data-mp="3brm2e3km8bhh">— {testimonial.attribution}</span>
              <a href={testimonial.href} target="_blank" rel="noopener noreferrer" className="focus-ring group inline-flex min-h-[44px] items-center gap-2 text-[14px] font-medium text-olive" data-id="element-53" data-mp="3gom6i8xwn45y">
                <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-54" data-mp="2t0coli3tb0k3">
                  Read client testimonials
                </span>
                <ArrowUpRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-55" data-mp="89ucqvtyc3mg" />
                <span className="sr-only" data-id="element-56" data-mp="8c8ajcg0ntxp">(opens in a new tab)</span>
              </a>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}